import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';

export const userColumns = [

  {
    field: "emrNumber",
    headerName: "Emr Number",
    width: 170,
    renderCell: (params) => {
      return (
        <a href="/patient-registration/basic-information">{params?.row?.emrNumber}</a>
      );
    },
  },
  {
    field: "name",
    headerName: "Patient Name",
    width: 120,
  },


  {
    field: "age",
    headerName: "Age / Sex",
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {
            params?.row?.gender === "0" ? <>{params.row.age} / Male</> :
              params?.row?.gender === "1" ? <>{params.row.age} /  Female</> : params.row.age + "/" + "Others"
          }

        </div>
      );
    },
    width: 150,
  },

  {
    field: "mobile",
    headerName: "Mobile",
    width: 150,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {
            <p><SmartphoneIcon /> {params.row.mobile} <WhatsAppIcon style={{color: "green"}} /></p>
          }

        </div>
      );
    }
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {
            <p><EmailIcon /> {params.row.email}</p>
          }

        </div>
      );
    }
  },
  {
    field: "address",
    headerName: "Address",
    width: 360,
  },
];
